import { FC } from "react"
import { Outlet } from "react-router-dom"

import { Grid } from "../../../ui-component/mui.components"

const CustomPackaging: FC = () => {
  return (
    <Grid container direction={"row"} justifyContent={"center"} minWidth={"lg"}>
      <Grid container maxWidth={"lg"} sx={{ alignContent: "flex-start" }}>
        <Outlet />
      </Grid>
    </Grid>
  )
}

export default CustomPackaging
